import http from "../http/http-config";

let stopLeads: boolean = false;

const isStoppedLeads = () => {
    return http.get<boolean>("LeadSettings/stop-leads")
        .then(response => {
            stopLeads = response.data;
        })
        .catch(error => {
            console.error("Error al obtener stopLeads", error);
        });
};
export default new class CRMCotizadorWebService {
    CreateOrEditLead(
        leadId, email, url, telephoneArea, telephoneNumber, productId, toQualify, applicationStep, additionalInformation: { [key: string]: string }, lastName, firstName
    ): Promise<string | null> {
        return isStoppedLeads().then(() => {
            if (stopLeads) {
                return null;
            }
            else {
                return http.post<string>("CreateOrEditLead", {
                    leadId,
                    email,
                    url,
                    telephoneArea,
                    telephoneNumber,
                    productId,
                    toQualify,
                    applicationStep,
                    additionalInformation,
                    lastName,
                    firstName
                }).then(response => response.data);
            }
        });
    }

    D365_AddFinishedQuotation(
        apellido, dni, localidad, mail, nombre, nroCotizacion, premioMensual, productoComercial, ramo, telephoneArea, telephoneNumber
    ): Promise<string> {
        return http.post<string>("D365_AddFinishedQuotation", {
            apellido
            , dni
            , localidad
            , mail
            , nombre
            , nroCotizacion
            , premioMensual
            , productoComercial
            , ramo
            , telephoneArea
            , telephoneNumber
        }).then(response => response.data)
    };
}
